/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentType } from '../../models/document-type';
import { GetDocumentResponse } from '../../models/get-document-response';

export interface GetUnfairTermsByType$Params {
  type: DocumentType;
}

export function getUnfairTermsByType(http: HttpClient, rootUrl: string, params: GetUnfairTermsByType$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDocumentResponse>> {
  const rb = new RequestBuilder(rootUrl, getUnfairTermsByType.PATH, 'get');
  if (params) {
    rb.path('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetDocumentResponse>;
    })
  );
}

getUnfairTermsByType.PATH = '/api/documents/unfair-terms/{type}';
